export default "__VITE_ASSET__sL7Ko9Fy__"